// Mock data for Muhammad Ibrahim Farrukh's Portfolio Shell OS

import myPhoto from "./IbrahimFarrukhGrad.jpg";

export const profileData = {
  name: "Muhammad Ibrahim Farrukh",
  tagline: "Applied ML Engineer | LLMs Research",
  photo: myPhoto, // Placeholder for professional photo
  email: "ibrahimfarrukh000@gmail.com",
  github: "https://github.com/fireblaster000",
  linkedin: "www.linkedin.com/in/muhammad-ibrahim-farrukh",
  location: "MSCS Dartmouth College'27",
  currentStatus: "Open to ML Engineering Opportunities",
  githubRepos: null,
  totalViews: null,
  languages: ["Python", "JavaScript", "TypeScript", "C++", "C", "SQL", "Haskell", "HTML5", "CSS3"],
  frameworks: ["Git", "Valgrind", "Postman", "Tableau", "n8n", "OpenGL", "Qt",
      "OpenAI", "Langchain", "LangGraph", "AI Agents", "Socket.io",
      "BeautifulSoup", "Regex", "VS Code", "AWS", "Docker", "MongoDB", "Supabase", "Pytorch", "TensorFlow", "Scikit-learn"]
};

export const projectsData = {
  "llm-research-assistant": {
    name: "LLM Research Assistant",
    description: "Advanced research assistant powered by fine-tuned language models for academic paper analysis and synthesis.",
    tech: ["Python", "PyTorch", "Transformers", "FAISS", "FastAPI"],
    github: "https://github.com/mibrahimfarrukh/llm-research-assistant",
    demo: "https://research-assistant-demo.vercel.app",
    features: [
      "Fine-tuned LLaMA 2 model for academic content",
      "Vector database integration for semantic search",
      "Real-time paper summarization and Q&A",
      "Multi-modal document processing"
    ],
    status: "Production Ready"
  },
  "multimodal-sentiment": {
    name: "Multimodal Sentiment Analysis",
    description: "Real-time sentiment analysis combining text, audio, and visual cues using transformer architectures.",
    tech: ["Python", "PyTorch", "OpenCV", "Whisper", "BERT"],
    github: "https://github.com/mibrahimfarrukh/multimodal-sentiment",
    demo: "https://sentiment-analyzer-demo.netlify.app",
    features: [
      "Multi-input sentiment detection",
      "Real-time webcam and microphone processing",
      "Custom transformer fusion architecture",
      "95.7% accuracy on benchmark datasets"
    ],
    status: "Research Phase"
  },
  "neural-style-transfer": {
    name: "Neural Style Transfer API",
    description: "High-performance style transfer service with custom CNN architectures and optimization techniques.",
    tech: ["Python", "TensorFlow", "PIL", "Docker", "Redis"],
    github: "https://github.com/mibrahimfarrukh/neural-style-api",
    demo: "https://style-transfer-api.herokuapp.com",
    features: [
      "Custom VGG-19 based architecture",
      "Real-time style transfer (< 2s processing)",
      "Batch processing capabilities",
      "RESTful API with rate limiting"
    ],
    status: "Production Ready"
  },
  "quantum-ml": {
    name: "Quantum Machine Learning Framework",
    description: "Experimental framework for quantum-classical hybrid machine learning algorithms.",
    tech: ["Python", "Qiskit", "Cirq", "NumPy", "Matplotlib"],
    github: "https://github.com/mibrahimfarrukh/quantum-ml-framework",
    demo: "https://quantum-ml-demo.streamlit.app",
    features: [
      "Quantum neural network implementations",
      "Variational quantum eigensolver for ML",
      "Quantum kernel methods",
      "Simulation on IBM Quantum backends"
    ],
    status: "Experimental"
  }
};

export const ongoingproj = [
  {
    title: "📈 Trading Platform",
    desc: "A real-time trading platform for secure item and cash exchanges with instant offers, notifications, and advanced browsing.",
    techStack: [
      "React 18 + TypeScript",
      "Tailwind CSS",
      "Node.js + Express.js",
      "MongoDB + Mongoose",
      "Socket.IO",
      "JWT & bcrypt",
    ],
    highlight:
      "Features JWT-secured auth, real-time Socket.IO offers, instant notifications, and advanced search & filtering.",
    link: "https://github.com/fireblaster000/Trading_App_firstwebsite",
  },
  {
    title: "🤖 AI Industry Pulse 🚀",
    desc: "An autonomous AI-powered platform generating professional blogs on AI trends via multi-agent collaboration.",
    techStack: ["AI Agents", "SEO Optimization", "Analytics", "Responsive Design"],
    highlight:
      "Research, content, SEO, and DevOps agents work together to auto-generate and deploy AI/tech blogs with live progress tracking.",
    link: "Coming Soon",
  },
  {
    title: "⚽ Fantasy Premier League AI Coach & ML Predictor",
    desc: "Machine learning-powered FPL predictor that optimizes weekly teams using historical data and ML models.",
    techStack: ["Python", "XGBoost", "Random Forests", "Data Modeling"],
    highlight:
      "Hit 72 points in GW1 vs. 47 manually. Using advanced ML models to surpass 2500+ points this season with chip modeling coming soon.",
    link: "https://github.com/fireblaster000/Fantasy-Premier-League-ML-predictor",
  },
];


export const completedprojs = [
  {
    title: "🏛️ 3D Reconstruction of Historical Landmarks (AR Deployment)",
    desc: "Built a full 3D reconstruction pipeline and deployed an AR Android app for interactive exploration.",
    techStack: ["Structure from Motion, Poisson Mesh, SIFT, RANSAC, Flutter, ar_flutter_plugin"],
    highlight: "Enabled AR visualization of reconstructed landmarks on mobile devices.",
    link: "https://github.com/fireblaster000/3D-Reconstruction-of-Historical-Landmarks-with-AR-Deployment"
  },
  {
    title: "☢️ Toxic Comment Classification",
    desc: "Designed an NLP pipeline for toxic comment detection using both classical ML and modern DL models.",
    techStack: ["LogReg, SVM, RNN, LSTM, BERT, PyTorch"],
    highlight: "Achieved top performance with Logistic Regression, Vanilla RNN, and Unfrozen BERT.",
    link: "https://github.com/fireblaster000/toxic-comment-multimodel-classification"
  },
  {
    title: "🧠 AI-Powered Learning Management System",
    desc: "Developed a smart LMS with AI-powered content summarization, quiz generation, and grading automation.",
    techStack: ["Next.js, FastAPI, PyTorch, RAG, LLM APIs, Together.AI, LangChain, LangGraph, Supabase"],
    highlight: "Reduced manual grading and prep time by 30–45 minutes per lecture.",
    link: "https://github.com/Jawamegamind/AI-Learning-Management-System"
  },
  {
    title: "📈 Succession Planning Software",
    desc: "Created an HR tool that predicts high-potential employees and matches mentors with mentees.",
    techStack: ["React, Vanilla CSS, Scikit-learn, MongoDB, Machine Learning"],
    highlight: "Delivered role-based dashboards with advanced security (2FA, RBAC, encryption).",
    link: "https://github.com/Mustafa-79/Succession-Planning"
  },
  {
  title: "🧩 C++ Puzzle Solver Suite",
  desc: "A sophisticated C++ application integrating advanced Rubik's Cube and Sudoku solvers with 3D graphics, computer vision, and intelligent algorithms.",
  techStack: ["C++, Qt5, OpenGL, OpenCV, Tesseract"],
  highlight: "Features real-time 3D Rubik’s Cube visualization, OCR-based Sudoku solving, intelligent algorithms, and a modern cross-platform GUI.",
  link: "https://github.com/fireblaster000/SolverSphere"
},
  {
    title: "🎓 LUMS Course Assistant",
    description:
      "A Retrieval-Augmented Generation (RAG) AI model for academic course selection at LUMS. It leverages embeddings, vector search, and Mistral-7B LLM to provide personalized course recommendations based on reviews and outlines.",
    techStack: [
      "LangChain",
      "Mistral-7B-Instruct",
      "ChromaDB",
      "OllamaEmbeddings",
      "Gradio",
    ],
    highlight:
      "471+ student reviews, 170+ course outlines, RAG-powered contextual responses, semester planning, and course difficulty insights.",
    link: "https://github.com/fireblaster000/Course-Recommender-RAG",
  },
  {
    title: "⚡ Electricity Distribution Billing System",
    description:
      "A full-stack billing management system for electricity distribution companies, built with FastAPI and Oracle DB, featuring real-time billing, payments, adjustments, and audit logging.",
    techStack: ["FastAPI", "Oracle Database", "SQL", "HTML/CSS/JS"],
    highlight:
      "Dynamic tariff/tax calculations, multi-method payment engine, officer-level adjustments with audit trails, and robust security validation.",
    link: "https://github.com/fireblaster000/Electricity-billing-web-app-sql",
  },
  {
    title: "📦 Delivery Service Simulation",
      description:
        "A C++ simulation of a parcel delivery service with OOP-driven design, supporting multiple shipping options, package tracking, and date-based delivery simulation.",
      techStack: ["C++", "OOP", "Inheritance", "Multi-level Inheritance"],
      highlight:
        "Dynamic memory management, delivery types with unique cost/time, admin system for tracking packages in transit, and date progression simulation.",
      link: "https://github.com/fireblaster000/Parcel-Delivery-System",
  },

];



export const experienceData = [
  {
    title: "Chief Technology Officer",
    company: "AMW International",
    period: "June 2022 - June 2025",
    startDate: "2022-06-01",
    endDate: "2025-06-30",
    location: "Lahore, Pakistan",
    description: "Led technology-driven transformation initiatives across operations, data management, and workflow optimization.",
    achievements: [
      "Built a centralized database to track sales, purchases, and financials, reducing errors and improving reporting.",
      "Digitized company records, cutting retrieval time by 40% and streamlining operations.",
      "Optimized workflows through data analysis, contributing to a 10% annual revenue increase.",
      "Trained 15+ staff on custom tools for inventory, shifts, and HR tasks, reducing manual errors by 30%."
    ],
    link:""
  },
  {
    title: "Research Assistant",
    company: "Centre for Urban Informatics, Technology, and Policy (CITY), LUMS",
    period: "July 2024 - June 2025",
    startDate: "2024-07-01",
    endDate: "2025-06-30",
    location: "Lahore, Pakistan",
    description: "Explored integration of LLMs into robotics to replace traditional reinforcement learning for multi-agent warehouse navigation systems.",
    achievements: [
      "Developed a multi-agent pathfinding framework leveraging LLMs for efficient warehouse navigation.",
      "Designed and fine-tuned a GPT-3.5 Turbo-based system to generate real-time commands, achieving 94% accuracy in single-agent navigation.",
      "Implemented a dataset creation pipeline with BFS (single-agent) and CBS (multi-agent), improving accuracy to 80% in dual-agent tasks.",
      "Addressed issues like truncated outputs, collision handling, and agent position swaps through fine-tuned error-handling strategies.",
      "Generalized the framework for >2 agents by incorporating reinforcement learning principles and scalability-focused algorithms."
    ],
    link: "https://github.com/fireblaster000/Multi-Agent-Path-Navigation-via-LLM"
  },
  {
    title: "Research Intern - Federated Learning",
    company: "CITY Lab, LUMS",
    period: "September 2024 - June 2025",
    startDate: "2024-09-01",
    endDate: "2025-06-30",
    location: "Lahore, Pakistan",
    description: "Focused on addressing client drift challenges in Federated Learning under heterogeneous data distributions.",
    achievements: [
      "Proposed novel latent space alignment techniques to reduce client drift in federated learning.",
      "Achieved state-of-the-art 76.88% accuracy on CIFAR-10 under label and quantity skew scenarios.",
      "Conducted experiments to benchmark FL systems on heterogeneous environments."
    ],
    link: "https://github.com/MSafiullah1/Latent-Alignment-in-FL",
  }
];

export const teachingExperience = [
  {
    title: "Teaching Assistant for CS-437: Deep Learning",
    University: "LUMS (Dr. Murtaza Taj)",
    period: "Jan 2025 – May 2025",
    startDate: "2025-01-01",
    endDate: "2025-05-30",
    location: "Lahore, Pakistan",
    description:
      "Assisted students in mastering CNNs, RNNs, Transformers, and diffusion modelling through tutorials and coding assignments. Guided implementation of deep learning models in PyTorch and provided mentorship on semester projects."
  },
  {
    title: "Teaching Assistant for AI-501: Mathematics of AI",
    University: "LUMS (Dr. Zubair Khalid)",
    period: "Aug 2024 – Dec 2024",
    startDate: "2024-08-01",
    endDate: "2024-12-31",
    location: "Lahore, Pakistan",
    description:
      "Supported the inaugural AI Master's program by designing flexible course material, conducting office hours, and assisting 80+ students with assignments on Linear Algebra and AI fundamentals. Improved student engagement with interactive sessions and digital participation tracking."
  },
  {
    title: "Teaching Assistant for CS-501: Applied Probability",
    University: "LUMS (Dr. Momin Ayub Uppal)",
    period: "Aug 2024 – Dec 2024",
    startDate: "2024-08-01",
    endDate: "2024-12-31",
    location: "Lahore, Pakistan",
    description:
      "Led weekly tutorials and office hours for 80+ students, simplifying probability concepts through problem-solving sessions. Graded assignments, provided detailed feedback, and co-designed homework sets on random processes and Gaussian distributions."
  },
  {
    title: "Teaching Assistant for CS-331: Introduction to AI",
    University: "LUMS (Dr. Muhammad Tahir)",
    period: "Jan 2024 – May 2024",
    startDate: "2024-01-01",
    endDate: "2024-05-31",
    location: "Lahore, Pakistan",
    description:
      "Conducted tutorials and developed assignments on Regression and Neural Networks for 130+ students. Assisted in grading exams and provided practical coding exercises to improve hands-on learning of AI concepts."
  },
  {
    title: "Teaching Assistant for CS-535: Machine Learning",
    University: "LUMS (Dr. Momin Ayub Uppal)",
    period: "Jan 2024 – May 2024",
    startDate: "2024-01-01",
    endDate: "2024-05-31",
    location: "Lahore, Pakistan",
    description:
      "Designed assignments on Regression and SVMs, and guided 60+ students through coding and optimization challenges. Provided feedback on quizzes and projects, strengthening practical understanding of ML algorithms. I also helped in designing a leaderboard for every programming assignment making students compete with each other based on evaluation metrics."
  },
  
  {
    title: "Teaching Assistant for CS-202: Data Structures",
    University: "LUMS (Dr. Agha Ali Raza)",
    period: "Aug 2023 – Dec 2023",
    startDate: "2023-08-01",
    endDate: "2023-12-31",
    location: "Lahore, Pakistan",
    description:
      "Led tutorials on trees, hashing, and sorting for 90+ students. Designed quizzes and assignments, assisted in grading, and created practical exercises (e.g., B-trees) to strengthen understanding of core data structures."
  }
];



export const achievementsData = [
  {
    type: "SCHOLARSHIP",
    title: "100% Merit Scholarship at LUMS",
    description: "Awarded to the top five students in the program for maintaining the highest CGPA throughout their academic journey.",
    startDate: "2021-09-01",
    endDate: "2025-06-30",
    link: "" 
  },
  {
    type: "SCHOLARSHIP",
    title: "Graduate Scholarship at Dartmouth College",
    description: "Selected for a prestigious scholarship in the MSCS program, recognizing outstanding academic achievement and research potential.",
    startDate: "2025-09-01",
    endDate: "2027-06-30",
    link: "" 
  },
  {
    type: "NOMINATION",
    title: "Valedictorian Nominee",
    description: "Chosen as one of the top five finalists for valedictorian from a graduating class of 1,500 students — the sole representative from the School of Science.",
    startDate: "2025-05-01",
    endDate: "2025-06-30",
    link: "" 
  },
  {
    type: "AWARD",
    title: "Leadership Excellence Award",
    description: "Recognized as the most impactful leader among 50+ student organizations at LUMS for driving initiatives, creating impact, and demonstrating exceptional leadership skills.",
    startDate: "2023-05-01",
    endDate: "2023-06-30",
    link: "" 
  },
  {
    type: "AWARD",
    title: "Dean's Honor List",
    description: "Consistently achieved academic distinction (CGPA 3.8+) across multiple semesters: Fall 2021, Spring 2022, Fall 2022, Spring 2023, Fall 2023, Spring 2024, Fall 2024, and Spring 2025.",
    startDate: "2021-12-01",
    endDate: "2025-05-30",
    link: "" 
  }
];



export const skillsData = {
  "Programming Languages": [
    "Python",
    "JavaScript",
    "TypeScript",
    "C++",
    "C",
    "R",
    "Julia",
    "Haskell",
    "SQL",
    "HTML5",
    "CSS3"
  ],
  "AI / ML & Data Science": [
    "PyTorch",
    "TensorFlow",
    "Scikit-learn",
    "XGBoost",
    "LightGBM",
    "OpenCV",
    "Pandas",
    "NumPy",
    "Matplotlib",
    "Jupyter",
    "Kaggle",
    "Google Colab"
  ],
  "Deep Learning & LLMs": [
    "Transformers",
    "CNNs",
    "RNNs",
    "GANs",
    "VAEs",
    "BERT",
    "GPT",
    "T5",
    "LLaMA",
    "Whisper",
    "CLIP",
    "Hugging Face"
  ],
  "MLOps & Experiment Tracking": [
    "Docker",
    "Kubernetes",
    "MLflow",
    "Weights & Biases",
    "DVC",
    "LangChain",
    "LangGraph",
    "AI Agents"
  ],
  "Frontend Development": [
    "React",
    "Next.js",
    "Vue.js",
    "Flutter",
    "Tailwind CSS",
    "Material UI",
    "Streamlit",
    "Gradio"
  ],
  "Backend Development": [
    "Node.js",
    "FastAPI",
    "Express.js",
    "Django",
    "Flask",
    "GraphQL",
    "Socket.io",
    "n8n"
  ],
  "Databases & Storage": [
    "MongoDB",
    "PostgreSQL",
    "Redis",
    "MySQL",
    "Supabase",
    "Firebase"
  ],
  "Cloud & Infrastructure": [
    "AWS",
    "Google Cloud",
    "Azure",
    "Terraform",
    "Ray",
    "Vercel",
    "Netlify",
    "Railway"
  ],
  "Tools & Frameworks": [
    "Git",
    "Valgrind",
    "Postman",
    "Tableau",
    "OpenGL",
    "Qt",
    "BeautifulSoup",
    "Regex",
    "VS Code",
    "Notion",
    "LaTeX",
    "Papers with Code",
    "arXiv",
    "stripe",
    "gradio",
    "streamlit"
  ]
};


export const systemCommands = {
  "ls": {
    description: "List directory contents",
    usage: "ls [directory]",
    directories: ["/about", "/projects", "/experience", "/contact", "/achievements", "/skills", "/research"]
  },
  "cd": {
    description: "Change directory",
    usage: "cd <directory>",
    example: "cd /projects"
  },
  "cat": {
    description: "Display file contents",
    usage: "cat <file>",
    example: "cat about.txt"
  },
  "pwd": {
    description: "Show current directory path",
    usage: "pwd"
  },
  "help": {
    description: "Show available commands",
    usage: "help [command]"
  },
  "clear": {
    description: "Clear terminal screen",
    usage: "clear"
  },
  "theme": {
    description: "Change visual theme",
    usage: "theme <theme-name>",
    themes: ["matrix", "cyberpunk", "galaxy", "minimal", "hacker", "neon", "retro", "accessible"]
  },
  "whoami": {
    description: "Display user information",
    usage: "whoami"
  },
  "fortune": {
    description: "Display random quote",
    usage: "fortune"
  },
  "ascii": {
    description: "Display ASCII art",
    usage: "ascii [text]"
  },
  "sudo": {
    description: "Execute with elevated privileges",
    usage: "sudo <command>",
    easter_eggs: ["sudo hire ibrahim", "sudo make coffee", "sudo rm -rf /"]
  },
  "nano": {
    description: "Open text editor",
    usage: "nano <file>",
    example: "nano resume.txt"
  },
  "games": {
    description: "Access mini-games",
    usage: "games"
  },
  "motd": {
    description: "Message of the day",
    usage: "motd"
  }
};

export const themesData = {
  aurora: {
    name: "Aurora Borealis",
    description: "Mystical northern lights dancing across the interface",
    colors: {
      background: "linear-gradient(135deg, #0c0c1e 0%, #1a1a3a 50%, #2d1b69 100%)",
      text: "#E8F4FD",
      accent: "#00F5FF",
      secondary: "#7B68EE"
    }
  },
  neon_synthwave: {
    name: "Neon Synthwave",
    description: "Retro-futuristic 80s aesthetic with neon grids",
    colors: {
      background: "linear-gradient(135deg, #0a0a0a 0%, #1a0a1a 50%, #0a1a1a 100%)",
      text: "#FF00FF",
      accent: "#00FFFF",
      secondary: "#FF1493"
    }
  },
  cosmic_void: {
    name: "Cosmic Void",
    description: "Deep space with swirling cosmic dust and distant stars",
    colors: {
      background: "radial-gradient(ellipse at center, #1a1a2e 0%, #16213e 50%, #0f0f23 100%)",
      text: "#E6E6FA",
      accent: "#9370DB",
      secondary: "#4169E1"
    }
  },
  digital_forest: {
    name: "Digital Forest",
    description: "Organic code growth patterns like digital trees",
    colors: {
      background: "linear-gradient(135deg, #0d1117 0%, #0a2f1f 50%, #051b11 100%)",
      text: "#98FB98",
      accent: "#00FF7F",
      secondary: "#32CD32"
    }
  },
  cyberpunk_city: {
    name: "Cyberpunk City",
    description: "Neon-lit metropolis with holographic overlays",
    colors: {
      background: "linear-gradient(135deg, #0a0a0a 0%, #2d1b69 30%, #ff006e 60%, #0a0a0a 100%)",
      text: "#FFFFFF",
      accent: "#FF006E",
      secondary: "#00F5FF"
    }
  },
  quantum_realm: {
    name: "Quantum Realm",
    description: "Particle physics visualization with quantum effects",
    colors: {
      background: "radial-gradient(circle at 30% 70%, #1a1a2e 0%, #16213e 30%, #e94560 60%, #1a1a2e 100%)",
      text: "#E94560",
      accent: "#FFD23F",
      secondary: "#EE5A24"
    }
  },
  neural_network: {
    name: "Neural Network",
    description: "Animated neural connections and synapses",
    colors: {
      background: "linear-gradient(135deg, #0f0f0f 0%, #1e3a8a 30%, #3b82f6 60%, #0f0f0f 100%)",
      text: "#DBEAFE",
      accent: "#60A5FA",
      secondary: "#3B82F6"
    }
  },
  matrix_reloaded: {
    name: "Matrix Reloaded",
    description: "Enhanced matrix with flowing binary cascades",
    colors: {
      background: "linear-gradient(135deg, #000000 0%, #001100 50%, #002200 100%)",
      text: "#00FF41",
      accent: "#39FF14",
      secondary: "#00CC33"
    }
  },
  sunset_gradient: {
    name: "Sunset Gradient",
    description: "Warm sunset colors with soft transitions",
    colors: {
      background: "linear-gradient(135deg, #1a1a1a 0%, #ff7f50 30%, #ff6b6b 60%, #ffd93d 90%, #1a1a1a 100%)",
      text: "#FFFFFF",
      accent: "#FFD93D",
      secondary: "#FF7F50"
    }
  },
  holographic: {
    name: "Holographic",
    description: "Iridescent holographic effects with rainbow shifts",
    colors: {
      background: "linear-gradient(45deg, #000000 0%, #1a1a2e 25%, #16213e 50%, #1a1a2e 75%, #000000 100%)",
      text: "#FFFFFF",
      accent: "#FF00FF",
      secondary: "#00FFFF"
    }
  },
  minimal_zen: {
    name: "Minimal Zen",
    description: "Clean minimalist design with subtle accents",
    colors: {
      background: "#000000",
      text: "#FFFFFF",
      accent: "#00FFD1",
      secondary: "#333333"
    }
  },
  retro_terminal: {
    name: "Retro Terminal",
    description: "Classic amber phosphor display aesthetic",
    colors: {
      background: "#000000",
      text: "#FFBF00",
      accent: "#FFA500",
      secondary: "#FF8C00"
    }
  }
};

export const fortuneQuotes = [
  "The best way to predict the future is to implement it.",
  "Machine learning is like teenage sex: everyone talks about it, few really know how to do it.",
  "There are only 10 types of people: those who understand binary and those who don't.",
  "Code is like humor. When you have to explain it, it's bad.",
  "A neural network is just a very complicated way to fit a curve.",
  "In machine learning, garbage in, garbage out. But sometimes, magic in between.",
  "The only way to learn machine learning is to machine learn machine learning.",
  "Debugging is twice as hard as writing the code. So make your code simple."
];

export const motdMessages = [
  "🚀 Currently researching quantum-classical hybrid learning algorithms",
  "🧠 Fun fact: I've trained models with over 100 billion parameters",
  "⚡ My fastest inference time: 12ms for real-time sentiment analysis",
  "🎯 Published 7 research papers with 200+ citations",
  "🌟 Contributed to 3 open-source ML frameworks with 10K+ stars",
  "🔬 Currently exploring multimodal transformer architectures",
  "💡 Invented a novel attention mechanism reducing compute by 30%",
  "🏆 Won 'Best AI Innovation' at Global AI Summit 2023"
];